(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ContactUs',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});


}(jQuery, window.Adzuki || {}));
